import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ApilistService {
  apiService: any = [
    {
      key: 'weblogin',
      path: 'weblogin',
      method: 'POST',
    },
    {
      key: 'login',
      path: 'login',
      method: 'POST',
    },
    {
      key: 'state',
      path: 'state',
      method: 'POST',
    },
    {
      key: 'state',
      path: 'state',
      method: 'GET',
    },
    {
      key: 'deletestate',
      path: 'deletestate',
      method: 'POST',
    },
    {
      key: 'district',
      path: 'district',
      method: 'POST',
    },
    {
      key: 'district',
      path: 'district',
      method: 'GET',
    },
    {
      key: 'deletedistrict',
      path: 'deletedistrict',
      method: 'POST',
    },
    {
      key: 'college',
      path: 'college',
      method: 'POST',
    },
    {
      key: 'college',
      path: 'college',
      method: 'GET',
    },
    {
      key: 'individualcollegedetails',
      path: 'individualcollegedetails',
      method: 'GET',
    },
    {
      key: 'editcollege',
      path: 'editcollege',
      method: 'POST',
    },
    {
      key: 'deletecollege',
      path: 'deletecollege',
      method: 'POST',
    },
    {
      key: 'scope',
      path: 'scope',
      method: 'POST',
    },
    {
      key: 'scope',
      path: 'scope',
      method: 'GET',
    },
    {
      key: 'editscope',
      path: 'editscope',
      method: 'POST',
    },
    {
      key: 'deletescope',
      path: 'deletescope',
      method: 'POST',
    },
    {
      key: 'collegedetails',
      path: 'collegedetails',
      method: 'POST',
    },
    {
      key: 'collegedetails',
      path: 'collegedetails',
      method: 'GET',
    },
    {
      key: 'editcollegedetails',
      path: 'editcollegedetails',
      method: 'POST',
    },
    {
      key: 'individualcollegecourse',
      path: 'individualcollegecourse',
      method: 'GET',
    },
    {
      key: 'degree',
      path: 'degree',
      method: 'POST',
    },
    {
      key: 'degree',
      path: 'degree',
      method: 'GET',
    },
    {
      key: 'deletedegree',
      path: 'deletedegree',
      method: 'POST',
    },
    {
      key: 'coursedetails',
      path: 'coursedetails',
      method: 'POST',
    },
    {
      key: 'coursedetails',
      path: 'coursedetails',
      method: 'GET',
    },
    {
      key: 'editcoursedetails',
      path: 'editcoursedetails',
      method: 'POST',
    },
    {
      key: 'deletecoursedetails',
      path: 'deletecoursedetails',
      method: 'POST',
    },
    {
      key: 'course',
      path: 'course',
      method: 'POST',
    },
    {
      key: 'course',
      path: 'course',
      method: 'GET',
    },
    {
      key: 'deletecourses',
      path: 'deletecourses',
      method: 'POST',
    },
    {
      key: 'coursetype',
      path: 'coursetype',
      method: 'POST',
    },
    {
      key: 'coursetype',
      path: 'coursetype',
      method: 'GET',
    },
    {
      key: 'deletecoursetype',
      path: 'deletecoursetype',
      method: 'POST',
    },
    {
      key: 'degreetype',
      path: 'degreetype',
      method: 'POST',
    },
    {
      key: 'degreetype',
      path: 'degreetype',
      method: 'GET',
    },
    {
      key: 'deletedegreetype',
      path: 'deletedegreetype',
      method: 'POST',
    },
    {
      key: 'userroles',
      path: 'userroles',
      method: 'POST',
    },
    {
      key: 'userroles',
      path: 'userroles',
      method: 'GET',
    },
    {
      key: 'users',
      path: 'users',
      method: 'POST',
    },
    {
      key: 'dashboardtype',
      path: 'dashboardtype',
      method: 'GET',
    },
    {
      key: 'dashboard',
      path: 'dashboard',
      method: 'POST',
    },
    {
      key: 'dashboard',
      path: 'dashboard',
      method: 'GET',
    },
    {
      key: 'removedashboard',
      path: 'removedashboard',
      method: 'POST',
    },
    {
      key: 'otp',
      path: 'otp',
      method: 'POST',
    },
    {
      key: 'verifyotp',
      path: 'verifyotp',
      method: 'POST',
    },
    {
      key: 'count',
      path: 'count',
      method: 'GET',
    },
    {
      key: 'studentlist',
      path: 'studentlist',
      method: 'GET',
    },
    {
      key: 'editpassword',
      path: 'editpassword',
      method: 'POST',
    },
    {
      key: 'videourl',
      path: 'videourl',
      method: 'POST',
    },
    {
      key: 'allvideourl',
      path: 'allvideourl',
      method: 'GET',
    },
    {
      key: 'deletecollegevideo',
      path: 'deletecollegevideo',
      method: 'POST',
    },
    {
      key: 'collegeimage',
      path: 'collegeimage',
      method: 'POST',
    },
    {
      key: 'allcollegeimage',
      path: 'allcollegeimage',
      method: 'GET',
    },
    {
      key: 'deletecollegeimage',
      path: 'deletecollegeimage',
      method: 'POST',
    },
    {
      key: 'country',
      path: 'country',
      method: 'POST',
    },
    {
      key: 'country',
      path: 'country',
      method: 'GET',
    },
    {
      key: 'alltrendingcourse',
      path: 'alltrendingcourse',
      method: 'GET',
    },
    {
      key: 'allforeignuniversity',
      path: 'allforeignuniversity',
      method: 'GET',
    },
    {
      key: 'useradmissionform',
      path: 'useradmissionform',
      method: 'GET',
    },
    {
      key: 'downloaduseradmissionform',
      path: 'downloaduseradmissionform',
      method: 'GET',
    },
    {
      key: 'deletecollegedetails',
      path: 'deletecollegedetails',
      method: 'POST',
    },
    {
      key: 'updatepaymenttype',
      path: 'updatepaymenttype',
      method: 'POST',
    },
    {
      key: 'paymenttype',
      path: 'paymenttype',
      method: 'GET',
    },
    {
      key: 'payment',
      path: 'payment',
      method: 'GET',
    },

    {
      key: 'category',
      path: 'materialcategory',
      method: 'POST',
    },

    {
      key: 'getcategory',
      path: 'materialcategory',
      method: 'GET',
    },

    {
      key: 'addsubject',
      path: 'materialsubject',
      method: 'POST',
    },

    {
      key: 'materialsubject',
      path: 'materialsubject',
      method: 'GET',
    },

    {
      key: 'materialonlysubject',
      path: 'viewonlymaterialsubject',
      method: 'POST',
    },

    {
      key: 'materialdocx',
      path: 'materialdocx',
      method: 'POST',
    },
    {
      key: 'trendingcollege',
      path: 'trendingcollege',
      method: 'POST',
    },
    {
      key: 'trendingcolleges',
      path: 'trendingcollege',
      method: 'GET',
    },

    {
      key: 'trendingnews',
      path: 'trendingnews',
      method: 'POST',
    },

    {
      key: 'trendingnewss',
      path: 'trendingnews',
      method: 'GET',
    },

    {
      key: 'allmaterialdocx',
      path: 'allmaterialdocx',
      method: 'GET',
    },

    {
      key: 'viewallusermaterialsubscriptiondetails',
      path: 'viewallusermaterialsubscriptiondetails',
      method: 'GET',
    },

    {
      key: 'allmaterialsubscribeddetails',
      path: 'allmaterialsubscribeddetails',
      method: 'GET',
    },

    {
      key: 'materialsubscription',
      path: 'materialsubscription',
      method: 'POST',
    },
    {
      key: 'allmaterialsubscription',
      path: 'allmaterialsubscription',
      method: 'GET',
    },

    {
      key: 'materialsyllabuss',
      path: 'materialsyllabus',
      method: 'GET',
    },

    {
      key: 'materialsyllabus',
      path: 'materialsyllabus',
      method: 'POST',
    },

    {
      key: 'colgfeesimg',
      path: 'colgfeesimg',
      method: 'POST',
    },
    {
      key: 'delfeesimg',
      path: 'delfeesimg',
      method: 'POST',
    },

    {
      key: 'trendingimgdelete',
      path: 'deletenewsimg',
      method: 'POST',
    },
    {
      key: 'trendingallimgdelete',
      path: 'deletetrndnews',
      method: 'POST',
    },

    {
      key: 'topcolimagedelete',
      path: 'deleteclgimg',
      method: 'POST',
    },
    {
      key: 'topcolimagedeleteall',
      path: 'deletetrndclg',
      method: 'POST',
    },

    {
      key: 'materialcatergory',
      path: 'deletematerialcatergory',
      method: 'POST',
    },

    {
      key: 'materialcatergorysubject',
      path: 'deletematerialcatergorysubject',
      method: 'POST',
    },

    {
      key: 'materialcatergorydocument',
      path: 'deletematerialcatergorydocument',
      method: 'POST',
    },

    {
      key: 'materialcatergorysyllabus',
      path: 'deletematerialcatergorysyllabus',
      method: 'POST',
    },

    {
      key: 'materialcatergorysubcription',
      path: 'deletematerialcatergorysubcription',
      method: 'POST',
    },
    {
      key: 'dashboardneet',
      path: 'dashboardneet',
      method: 'GET',
    },
    {
      key: 'dashboardurl',
      path: 'dashboardurl',
      method: 'POST',
    },
    {
      key: 'dashboardvideo',
      path: 'dashboardvideo',
      method: 'GET',
    },
    {
      key: 'removedashboardurl',
      path: 'removedashboardurl',
      method: 'POST',
    },
    {
      key: 'addtrendingnewsimage',
      path: 'trendingnewsimage',
      method: 'POST',
    },
    {
      key: 'addtopimage',
      path: 'trendingcollegeimage',
      method: 'POST',
    },
    {
      key: 'coursepaymenttype',
      path: 'paymentdetails/course',
      method: 'GET',
    },

    {
      key: 'userPermissionallow',
      path: 'editcountallow',
      method: 'POST',
    },
    {
      key: 'foreigncourses',
      path: 'foreign_course',
      method: 'GET',
    },
    {
      key: 'addforeigncourse',
      path: 'foreign_course',
      method: 'POST',
    },
    {
      key: 'foreigncolleges',
      path: 'foreign_college',
      method: 'GET',
    },
    {
      key: 'addforeigncollege',
      path: 'foreign_college',
      method: 'POST',
    },
    {
      key: 'foreigncoursesbycountry',
      path: 'foreign_course',
      method: 'GET',
    },
    {
      key: 'foreigncollegefees',
      path: 'foreign_college_fees',
      method: 'GET',
    },
    {
      key: 'addforeigncollegefees',
      path: 'foreign_college_fees',
      method: 'POST',
    },
  ];
  constructor() {}
  getApiConfigs(key: string) {
    return this.apiService.filter((item) => {
      if (item.key == key) {
        return item;
      }
    });
  }
}
